document.addEventListener("DOMContentLoaded", function () {
  const getElement = (id) => document.getElementById(id);
  const toggleClass = (el, className, condition) =>
    el?.classList.toggle(className, condition);

  const searchInput = getElement("search-input");
  const searchForm = getElement("predictive-search");
  const searchResultsContainer = getElement("search-results");
  const searchCategoryProduct = getElement("search-category-product");
  const searchCategoryCollection = getElement("search-category-collection");
  const searchResultsProductContainer = getElement("product-results-container");
  const searchResultsCollectionContainer = getElement(
    "collection-results-container"
  );
  const noResultsMessage = getElement("no-results");

  searchForm.addEventListener("submit", function (e) {
    e.preventDefault();
  });

  searchInput.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      return false;
    } else {
      handleSearchInput({ target: searchInput });
    }
  });

  searchCategoryProduct.addEventListener("click", function () {
    toggleClass(searchCategoryProduct, "underline", true);
    toggleClass(searchCategoryProduct, "font-medium", true);
    toggleClass(searchCategoryCollection, "underline", false);
    toggleClass(searchCategoryCollection, "font-medium", false);
    toggleClass(searchResultsProductContainer, "hidden", false);
    toggleClass(searchResultsCollectionContainer, "hidden", true);
  });

  searchCategoryCollection.addEventListener("click", function () {
    toggleClass(searchCategoryProduct, "underline", false);
    toggleClass(searchCategoryProduct, "font-medium", false);
    toggleClass(searchCategoryCollection, "underline", true);
    toggleClass(searchCategoryCollection, "font-medium", true);
    toggleClass(searchResultsProductContainer, "hidden", true);
    toggleClass(searchResultsCollectionContainer, "hidden", false);
  });

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  const handleSearchInput = debounce(function (event) {
    const query = event.target.value.trim();

    if (query.length < 1) {
      searchResultsContainer.classList.add("hidden");
      noResultsMessage.classList.add("hidden");
      return;
    }

    fetch(
      `/search/suggest.json?q=${encodeURIComponent(
        query
      )}&resources[type]=product,collection&resources[options][unavailable_products]=hide`
    )
      .then((res) => res.json())
      .then((suggestions) => {
        const products = suggestions.resources.results.products || [];
        const collections = suggestions.resources.results.collections || [];

        searchResultsProductContainer.innerHTML = "";
        searchResultsCollectionContainer.innerHTML = "";

        if (products.length === 0 && collections.length === 0) {
          searchResultsContainer.classList.remove("hidden");
          noResultsMessage.classList.remove("hidden");
          toggleClass(searchCategoryProduct, "hidden", true);
          toggleClass(searchCategoryCollection, "hidden", true);
          return;
        } else {
          noResultsMessage.classList.add("hidden");
        }

        searchResultsContainer.classList.remove("hidden");

        if (products.length > 0) {
          toggleClass(searchCategoryProduct, "hidden", false);
          toggleClass(searchCategoryProduct, "underline", true);
          toggleClass(searchResultsProductContainer, "hidden", false);

          products.forEach((product) => {
            const anchor = document.createElement("a");
            anchor.href = product.url;
            anchor.className =
              "flex items-center gap-4 hover:bg-gray-100 p-2 rounded transition";

            const img = document.createElement("img");
            img.src = product.image;
            img.className = "w-14 h-14 object-cover rounded";
            anchor.appendChild(img);

            const textWrap = document.createElement("div");
            textWrap.innerHTML = `
                <div class="text-sm font-medium">${product.title}</div>
               ${
                 product.price == 0 || product.price === "0"
                   ? `<div class="text-xs text-[#f15c20] font-semibold">Get a quote</div>`
                   : `<div class="text-xs text-gray-600">${product.price}</div>`
               }
              `;
            anchor.appendChild(textWrap);

            searchResultsProductContainer.appendChild(anchor);
          });
        } else {
          toggleClass(searchCategoryProduct, "hidden", true);
        }

        if (collections.length > 0) {
          toggleClass(searchCategoryCollection, "hidden", false);

          collections.forEach((collection) => {
            const anchor = document.createElement("a");
            anchor.href = collection.url;
            anchor.className =
              "block text-sm text-gray-800 py-2 hover:text-[#f15c20]";
            anchor.textContent = collection.title;
            searchResultsCollectionContainer.appendChild(anchor);
          });

          if (products.length === 0) {
            toggleClass(searchCategoryCollection, "underline", true);
            toggleClass(searchResultsCollectionContainer, "hidden", false);
          }
        } else {
          toggleClass(searchCategoryCollection, "hidden", true);
        }
      });
  }, 300);

  searchInput.addEventListener("input", handleSearchInput);

  document.addEventListener("click", (e) => {
    if (
      !e.target.closest("#predictive-search") &&
      !e.target.closest("#search-results")
    ) {
      searchResultsContainer.classList.add("hidden");
    }
  });
});
